import { apiRequest } from "@/lib/api/client";
import { logActivity } from "@/services/gpsdrive-activity-log.service";
import type { Geofence } from "@/types";

// Integração real com a API oficial do Traccar (GET/POST/PUT/DELETE
// /api/geofences) — mesmo padrão de vehicles.service.ts/users.service.ts/
// notifications.service.ts: sempre com credentials: "include", sem mock,
// sem fallback local. Falha já cai no catch-all de erro genérico de
// client.ts — aqui só loga o SUCESSO com o tipo específico (aba LOGS,
// Editar Usuário), pra não duplicar a mesma falha duas vezes.
export const geofencesService = {
  list: () => apiRequest<Geofence[]>("/api/geofences", { method: "GET", credentials: "include" }),
  get: (id: number) =>
    apiRequest<Geofence>(`/api/geofences/${id}`, { method: "GET", credentials: "include" }),
  create: async (data: Partial<Geofence>) => {
    const geofence = await apiRequest<Geofence>("/api/geofences", {
      method: "POST",
      credentials: "include",
      body: data,
    });
    logActivity({
      type: "GEOFENCE_CREATED",
      message: `Geocerca "${geofence.name ?? data.name ?? geofence.id}" criada`,
      metadata: { geofenceId: geofence.id, name: geofence.name },
    });
    return geofence;
  },
  update: async (id: number, data: Partial<Geofence>) => {
    const geofence = await apiRequest<Geofence>(`/api/geofences/${id}`, {
      method: "PUT",
      credentials: "include",
      body: data,
    });
    logActivity({
      type: "GEOFENCE_UPDATED",
      message: `Geocerca "${geofence.name ?? data.name ?? id}" editada`,
      metadata: { geofenceId: id, name: geofence.name },
    });
    return geofence;
  },
  remove: async (id: number) => {
    await apiRequest<void>(`/api/geofences/${id}`, { method: "DELETE", credentials: "include" });
    logActivity({
      type: "GEOFENCE_DELETED",
      message: `Geocerca #${id} excluída`,
      metadata: { geofenceId: id },
    });
  },
};
